"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditInput = void 0;
var SelectDropdown_1 = __importDefault(require("@components/SelectDropdown"));
var react_1 = __importDefault(require("react"));
var react_textarea_autosize_1 = __importDefault(require("react-textarea-autosize"));
function EditInput(_a) {
    var inputType = _a.inputType, cyName = _a.cyName, placeholderText = _a.placeholderText, tempValue = _a.tempValue, setTempValue = _a.setTempValue, handleKeyDown = _a.handleKeyDown, label = _a.label, textAreaRef = _a.textAreaRef, minVal = _a.minVal;
    if (inputType === 'text') {
        return (react_1.default.createElement(react_textarea_autosize_1.default, { minRows: 1, className: "textbox form-control inputs-should-respond-to-keyboard-arrows", placeholder: placeholderText, onChange: function (e) { return setTempValue(e.currentTarget.value); }, value: tempValue || '', onKeyDown: handleKeyDown, ref: textAreaRef, "data-cy": "job-field-".concat(cyName || label, "-input") }));
    }
    if (inputType === 'number') {
        return (react_1.default.createElement("input", { type: "number", className: "form-control inputs-should-respond-to-keyboard-arrows eva-text-box-component__input", placeholder: placeholderText, onChange: function (e) { return setTempValue(e.currentTarget.value); }, value: tempValue || '', onKeyDown: handleKeyDown, "data-cy": "job-field-".concat(cyName || label, "-input"), min: minVal }));
    }
    if (inputType === 'boolean') {
        return (react_1.default.createElement(SelectDropdown_1.default, { items: [
                { id: "true", text: 'true' },
                { id: "false", text: 'false' },
            ], onItemSelected: function (id) {
                setTempValue(id);
            }, selectedItemId: tempValue, "data-cy": "job-field-".concat(cyName || label, "-input") }));
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
}
exports.EditInput = EditInput;
